<template>
  <v-col>
    <v-row class="pa-10">
      <v-col
        v-if="logo"
        cols="12"
      >
        <v-img
          :src="'/storage/' + logo"
          lazy-src="/storage/default_img/no_image.png"
          :max-width="main.logoWidth"
          :max-height="main.logoHight"
        />
      </v-col>
      <v-col cols="12">
        <v-file-input
          v-model="upload"
          :messages="
            'Display Size : ' +
              main.logoWidth +
              ' ' +
              main.logoHight +
              ' (adjust form general settings)'
          "
          label="Select File"
          placeholder="Upload Logo"
          accept="image/jpg, image/png, image/jpeg"
        />
      </v-col>

      <v-card-actions>
        <v-btn
          :disabled="!upload"
          @click="logoUpdate"
        >
          Upload App Logo
        </v-btn>
      </v-card-actions>
    </v-row>
    <v-row class="pa-10">
      <v-col
        v-if="logo"
        cols="12"
      >
        <v-img
          :src="'/storage/' + logoBill"
          lazy-src="/storage/default_img/no_image.png"
          :max-width="main.billLogoWidth"
          :max-height="main.billLogoHeight"
        />
      </v-col>
      <v-col cols="12">
        <v-file-input
          v-model="uploadBill"
          :messages="
            'Display Size : ' +
              main.billLogoWidth +
              ' ' +
              main.billLogoHeight +
              ' (adjust from bill settings)'
          "
          label="Select File"
          placeholder="Upload Logo"
          accept="image/jpg, image/png, image/jpeg"
        />
      </v-col>

      <v-card-actions>
        <v-btn
          :disabled="!uploadBill"
          @click="logoBillUpdate"
        >
          Upload Billing Logo
        </v-btn>
      </v-card-actions>
    </v-row>
  </v-col>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      upload: null,
      uploadBill: null,
    };
  },
  computed: {
    ...mapGetters({
      errors: "validation/pull",
      logo: "configs/logo",
      logoBill: "configs/logoBill",
      main: "configs/overall",
    }),
  },

  methods: {
    logoUpdate() {
      if (this.upload !== null) {
        const formData = new FormData();
        formData.append("logo", this.upload, this.upload.name);
        window.axios.post("/setting-logo", formData).then((logo) => {
          if (logo.data.updated) {
            Event.$emit("bootConfigs", logo.data.updated, logo.data.message);
            this.upload = null;
          }
        });
      }
    },
    logoBillUpdate() {
      if (this.uploadBill !== null) {
        const formData = new FormData();
        formData.append("logoBill", this.uploadBill, this.uploadBill.name);
        window.axios.post("/setting-logo-bill", formData).then((logoBill) => {
          if (logoBill.data.updated) {
            Event.$emit(
              "bootConfigs",
              logoBill.data.updated,
              logoBill.data.message
            );
            this.uploadBill = null;
          }
        });
      }
    },
  },
};
</script>
